import React, { useState, useEffect } from 'react';
import './SupplierConfig.css';

function SupplierConfig({ stockData, onSuppliersConfigured }) {
  const [suppliers, setSuppliers] = useState([
    { id: 1, name: 'Fournisseur 1', leadTime: 14 }
  ]);
  const [productSuppliers, setProductSuppliers] = useState({});
  const [newSupplierName, setNewSupplierName] = useState('');
  const [newSupplierLeadTime, setNewSupplierLeadTime] = useState(14);

  // Identifie la clé SKU dans les données
  const getSkuKey = () => {
    if (!stockData || stockData.length === 0) return null;
    return 'sku' in stockData[0] ? 'sku' : 
           'SKU' in stockData[0] ? 'SKU' : 
           Object.keys(stockData[0])[0];
  };

  const skuKey = getSkuKey();

  // Ajouter un nouveau fournisseur
  const addSupplier = () => {
    if (newSupplierName.trim() === '') return;
    
    const newId = suppliers.length > 0 
      ? Math.max(...suppliers.map(s => s.id)) + 1 
      : 1;
    
    setSuppliers([
      ...suppliers, 
      { 
        id: newId, 
        name: newSupplierName, 
        leadTime: parseInt(newSupplierLeadTime) || 14 
      }
    ]);
    
    setNewSupplierName('');
    setNewSupplierLeadTime(14);
  };

  // Supprimer un fournisseur
  const removeSupplier = (id) => {
    setSuppliers(suppliers.filter(supplier => supplier.id !== id));
    
    // Retirer ce fournisseur des produits associés
    const updatedProductSuppliers = { ...productSuppliers };
    Object.keys(updatedProductSuppliers).forEach(sku => {
      if (updatedProductSuppliers[sku] === id) {
        delete updatedProductSuppliers[sku];
      }
    });
    
    setProductSuppliers(updatedProductSuppliers);
  };

  // Modifier le délai d'un fournisseur
  const updateSupplierLeadTime = (id, leadTime) => {
    setSuppliers(suppliers.map(supplier => 
      supplier.id === id 
        ? { ...supplier, leadTime: parseInt(leadTime) || 0 } 
        : supplier
    ));
  };

  // Associer un produit à un fournisseur
  const assignSupplier = (sku, supplierId) => {
    setProductSuppliers({
      ...productSuppliers,
      [sku]: parseInt(supplierId)
    });
  };

  // Sauvegarder la configuration
  const saveConfiguration = () => {
    // Préparer les données à sauvegarder
    const configData = {
      suppliers: suppliers,
      productSuppliers: productSuppliers
    };
    
    // Sauvegarder dans le localStorage
    localStorage.setItem('supplierConfig', JSON.stringify(configData));
    
    // Notifier le composant parent
    if (onSuppliersConfigured) {
      onSuppliersConfigured(configData);
    }
    
    alert('Configuration sauvegardée avec succès !');
  };

  // Charger la configuration sauvegardée au démarrage
  useEffect(() => {
    const savedConfig = localStorage.getItem('supplierConfig');
    if (savedConfig) {
      try {
        const config = JSON.parse(savedConfig);
        if (config.suppliers) setSuppliers(config.suppliers);
        if (config.productSuppliers) setProductSuppliers(config.productSuppliers);
      } catch (e) {
        console.error('Erreur lors du chargement de la configuration :', e);
      }
    }
  }, []);

  return (
    <div className="supplier-config">
      <h2>Configuration des fournisseurs</h2>
      
      <div className="config-section">
        <h3>Gérer les fournisseurs</h3>
        
        <div className="add-supplier">
          <input
            type="text"
            placeholder="Nom du fournisseur"
            value={newSupplierName}
            onChange={(e) => setNewSupplierName(e.target.value)}
          />
          <input
            type="number"
            placeholder="Délai (jours)"
            value={newSupplierLeadTime}
            onChange={(e) => setNewSupplierLeadTime(e.target.value)}
            min="1"
          />
          <button onClick={addSupplier}>Ajouter</button>
        </div>
        
        <table className="suppliers-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Délai de livraison (jours)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {suppliers.map(supplier => (
              <tr key={supplier.id}>
                <td>{supplier.name}</td>
                <td>
                  <input
                    type="number"
                    value={supplier.leadTime}
                    onChange={(e) => updateSupplierLeadTime(supplier.id, e.target.value)}
                    min="1"
                  />
                </td>
                <td>
                  <button 
                    className="remove-btn"
                    onClick={() => removeSupplier(supplier.id)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {stockData && stockData.length > 0 && skuKey && (
        <div className="config-section">
          <h3>Associer les produits aux fournisseurs</h3>
          
          <div className="product-list">
            <table className="product-supplier-table">
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Fournisseur</th>
                </tr>
              </thead>
              <tbody>
                {stockData.map((item, index) => (
                  <tr key={index}>
                    <td>{item[skuKey]}</td>
                    <td>
                      <select
                        value={productSuppliers[item[skuKey]] || ''}
                        onChange={(e) => assignSupplier(item[skuKey], e.target.value)}
                      >
                        <option value="">Sélectionner un fournisseur</option>
                        {suppliers.map(supplier => (
                          <option key={supplier.id} value={supplier.id}>
                            {supplier.name} ({supplier.leadTime} jours)
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      
      <div className="actions">
        <button className="save-btn" onClick={saveConfiguration}>
          Sauvegarder la configuration
        </button>
      </div>
    </div>
  );
}

export default SupplierConfig;